var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTable',{attrs:{"url":_vm.api.ACTIONS.BONUS_PACKAGE,"actionsExtraMain":_vm.actionsExtraMain,"enable-delete":false,"enable-edit":false,"fields-hidden-add":['created_at','id'],"fields-extra-add":_vm.fieldsExtraAdd,"input-types-add":{
                          slice: {items: ['DAILY', 'WEEKLY', 'MONTHLY', 'EVER'],clearable: true},
                          visibility: {items: ['ALL', 'CUSTOM', 'SATISFY'], clearable: true},
                          prise: {items: ['MAX', 'SATISFIED'], clearable: true},
                          penalty_type: {items: ['FIXED', 'REVENUE_PERCENTAGE'], clearable: true},
                          captain_expiration_from: {items: ['BONUS_JOIN_DATE', 'WASILNI_JOIN_DATE', 'CUSTOM', 'FIRST_RIDE'], clearable: true},
                 },"title":"Conditional Bonus"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }